import React from "react";
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

const Input = ({ name, label, error, ...rest }) => {
  return (
    <div>
      <TextField
        {...rest}
        name={name}
        label={label}
      />
      {error && <Typography color="error">{error}</Typography>}
    </div>
  );
};

export default Input;
